import { all } from 'redux-saga/effects';

import geometricInteractionSagas from './geometricInteractionSagas';
import sagas from './sagas';

const saga = function* () {
  yield all([geometricInteractionSagas(), sagas()]);
};

export default saga;
